import { Card } from 'antd';
import styled from 'styled-components';

const Cards = styled(Card)`
  min-width: 190px;
  width: 100%;
  margin: auto;
  min-height: 150px;
`;


export { Cards };
